import API from "api/axiosInstance";
import {
  resetSummaryAbsensi,
  setIsLoading,
  setListCabang,
  setListKaryawan,
  setListKaryawanWeb,
  setOptionsKaryawanWeb,
  setListKaryawanNotInputGaji,
  setListRekapTabunganKaryawan,
  setListTabunganKaryawan,
  setMessage,
  setStatus,
  setSummaryAbsensi,
} from "./index";

export const fetchListKaryawan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/karyawan/web-karyawan");
    dispatch(setIsLoading(false));
    dispatch(setListKaryawan(response.data.list_karyawan));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListKaryawanWeb =
  (params = {}) =>
  async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/karyawan/web-karyawan", { params });
      dispatch(setIsLoading(false));
      dispatch(
        setListKaryawanWeb({
          list: response.data.list_karyawan,
          pagination: response.data.pagination,
        }),
      );
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchOptionsKaryawanWeb = () => async (dispatch) => {
  try {
    const response = await API.get("/karyawan/web-karyawan", {
      params: { options: "nama_cab,nama_jabatan" },
    });
    dispatch(setOptionsKaryawanWeb(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  }
};

export const fetchListKaryawanNotListGaji =
  (bulan, tahun) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get(`/web-karyawan-belum-gaji`, {
        params: {
          bulan,
          tahun,
        },
      });
      dispatch(setIsLoading(false));
      dispatch(setListKaryawanNotInputGaji(response.data.data));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchSummaryAbsensi =
  (id_karyawan, bulan, tahun) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get(`/api/attendance/summary_absensi`, {
        params: {
          id_karyawan,
          bulan,
          tahun,
        },
      });
      dispatch(setIsLoading(false));
      dispatch(setSummaryAbsensi(response.data.data));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const resetSummary = () => async (dispatch) => {
  dispatch(resetSummaryAbsensi());
};

export const fetchListCabang = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/cabang");
    dispatch(setIsLoading(false));
    dispatch(setListCabang(response.data.cabangData));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteKaryawan = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/karyawan/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchChangeActiveKaryawan =
  (id_karyawan, change_to) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.post(`/karyawan-active`, {
        id_karyawan,
        change_to: change_to.toString(),
      });
      dispatch(setMessage(response.data.message));
      dispatch(setStatus("success"));
      dispatch(setIsLoading(false));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchSendNotifBirthday =
  (id_karyawan, change_to) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.post(`/karyawan-birthday`, {
        id_karyawan,
      });
      dispatch(setMessage(response.data.message));
      dispatch(setStatus("success"));
      dispatch(setIsLoading(false));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchAddKaryawan = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/karyawan", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchAddKaryawanBaru = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/karyawan/add-karyawan", redData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchListKaryawanWithTabungan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get(`/api/tabungan`);
    dispatch(setIsLoading(false));
    dispatch(setListTabunganKaryawan(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListRekapTabungan = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get(`/api/tabungan/rekap`);
    dispatch(setIsLoading(false));
    dispatch(setListRekapTabunganKaryawan(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchKreditTabungan = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/api/tabungan/kredit", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDebitTabungan = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/api/tabungan/debit", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server"),
    );
    dispatch(setStatus("failed"));
  }
};
